<template>
    <div class="rank">
        <rank-item v-show="index<=5" :key="index" v-bind:name="rank.name" :avatar="rank.avatar" :percent="rank.percentage" :revenue="rank.formated_revenue" v-for="(rank,index) in ranks" ></rank-item>
    </div>
</template>
<script>
import RankItem from '@/components/Rank/RankItem'

export default {
    name: 'Rank',
    components: {RankItem},
    data() {
        return {
            
        }
    },
    props:['ranks']
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/Rank.vue